'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function MoneyUpProductCell() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];
  this.presenter = null;
  this.analytics = null;

  this.state = null;
  this.product = null;
  this.analyticsState = null;
  this.contentExtensions = {};
  this.classNameExtensions = {};
  this.disclaimers = {};
  this.hasAlert = false;
  this.onReady = function () {};

  this._statusClassName = '';

  this._content = {
    loading: '',
    connectionIssue: "Can't connect <div>Try again</div>",
    error: "We can't connect. Try again later"
  };

  this._classNames = {
    disabled: MoneyUpProductCell.classNames.disabled,
    inactive: MoneyUpProductCell.classNames.inactive,
    active: MoneyUpProductCell.classNames.active,
    alert: MoneyUpProductCell.classNames.alert,
    loading: MoneyUpProductCell.classNames.loading,
    connectionIssue: MoneyUpProductCell.classNames.connectionIssue,
    error: MoneyUpProductCell.classNames.error
  };

  this.init = function () {
    this._content = _extends({}, this._content, this.contentExtensions);
    this._classNames = _extends({}, this._classNames, this.classNameExtensions);
    this._generateInitialUI();
  };

  this.initAllReady = function () {};

  this.initPage = function () {};

  this._generateInitialUI = function (html) {
    this.setState('loading');
    this.node.style.display = 'flex';
    this.onReady();
  };

  this.setState = function (newState, newAnalyticsState) {
    this.state = newState;
    this.analyticsState = newAnalyticsState;

    // set content based on state
    var contentSource = this._content[this.state];
    var content = '';
    if (contentSource !== undefined) {
      if (typeof contentSource === 'function') {
        content = contentSource();
      } else {
        content = contentSource;
      }
    }
    if (this.product === 'MogoCard' || this.product === 'MogoCrypto') {
      this.node.querySelector('.js--product-content').innerHTML = 'Discontinued';
    } else {
      this.node.querySelector('.js--product-content').innerHTML = content;
    }

    // show disclaimers if any
    var legalDisclaimerEl = document.getElementsByClassName('js--legal-disclaimer');
    if (this.disclaimers[this.state] && legalDisclaimerEl[0] && legalDisclaimerEl[0].mogo && legalDisclaimerEl[0].mogo().redraw) {
      var elementSelector = '.js--product-title';
      if (this.disclaimers[this.state].position && this.disclaimers[this.state].position === 'content') {
        elementSelector = '.js--product-content';
      }
      this.node.querySelector(elementSelector).dataset.legal = this.disclaimers[this.state].text;
      document.getElementsByClassName('js--legal-disclaimer')[0].mogo().redraw();
    }

    // set class (for ui)
    var oldClassName = this._statusClassName;
    var newClassName = this._classNames[this.state];
    if (oldClassName) {
      this.node.classList.remove(oldClassName);
      this.node.classList.add(newClassName);
    } else {
      this.node.classList.add(newClassName);
    }

    if (newClassName !== this._classNames.loading && newClassName !== this._classNames.connectionIssue) {
      this.node.classList.add('loaded');
    } else {
      this.node.classList.remove('loaded');
    }

    // store class name (for next status change)
    this._statusClassName = newClassName;
  };

  this.getState = function () {
    return this.state;
  };

  this.showAlert = function (hasAlert) {
    var alertClass = this._classNames.alert;
    if (hasAlert) {
      this.hasAlert = true;
      this.node.classList.add(alertClass);
    } else {
      this.hasAlert = false;
      this.node.classList.remove(alertClass);
    }

    // send product and status analytics
    this._pushAnalytics();
  };

  this.showCustomAlertState = function () {
    this.node.classList.add('dashboard-product-state--active-custom'); // make dial green here
  };

  this._pushAnalytics = function () {
    var alertStateText = '';

    // push HDCellStatus event
    if (this.analyticsState !== 'Loading') {
      alertStateText = this.hasAlert ? '|Alert' : '|Normal';
      this.analytics.pushEvent('hd-cell-status', {
        cell: [this.product],
        notification: ['' + this.analyticsState + alertStateText]
      });
    }

    // set data-anlytics-id
    this.node.dataset.analyticsId = this.product + '-Cell Navigation-' + this.analyticsState + alertStateText + '-Navigation-Component';
  };

  // utility functions that return common html string formats
  this._getFormattedMoneyHtml = function (amount) {
    var dollars = Formatters.formatMoney(amount, {
      decomposeResult: true,
      noCurrencySymbol: true
    })[0];
    var cents = Formatters.formatMoney(amount, {
      decomposeResult: true,
      noCurrencySymbol: true
    })[1];

    return '<div class="dashboard-product__content__data">\n      <span class="dashboard-product__content__data--small">$</span>\n      <span class="js--dollars">' + dollars + '</span>\n      <span class="dashboard-product__content__data--small js--cents">.' + cents + '</span>\n      </div>';
  };

  this._getTrendArrowHtml = function (upOrDown) {
    var content = upOrDown === '' ? '—' : '<svg class="svg-icon" viewbox="0 0 16 16"><use xlink:href="#up-arrow"></use></svg>';
    return '\n      <div class="dashboard-product__trend dashboard-product__trend-arrow dashboard-product__trend-arrow--' + upOrDown + ' js--trend">\n        ' + content + '\n      </div>';
  };

  this._getFormattedPercentageHtml = function (amount) {
    return '<div class="dashboard-product__content__data">\n      <span>' + Number(amount).toFixed(2) + '</span>\n      <span class="dashboard-product__content__data--small">%</span>\n      </div>';
  };
}

MoneyUpProductCell.classNames = {
  inactive: 'dashboard-product-state--inactive',
  active: 'dashboard-product-state--active',
  alert: 'dashboard-product-state--alert',
  loading: 'dashboard-product-state--loading',
  connectionIssue: 'dashboard-product-state--connection-issue',
  error: 'dashboard-product-state--error',
  disabled: 'dashboard-product-state--disabled'
};